import { UserInfo, ClearUserinfo } from "./action";

const user = (state = { userInfo: {} }, action: any) => {
  switch (action.type) {
    case UserInfo:
      return { ...state, userInfo: action.rs.value };
    case ClearUserinfo:
      return { ...state, userInfo: {} };
    default:
      return state;
  }
};

export default user;